import { Global } from "@emotion/react";

// This component provides custom fonts to the Chakra provider
const Fonts = () => {
  return (
    <Global
      styles={`
        /* latin */
        @font-face {
          font-family: 'BelfastGrotesk';
          font-style: normal;
          font-weight: 700;
          font-display: swap;
          src: local(''), url('/fonts/BelfastGrotesk-Black.ttf') format('truetype');
        }
        @font-face {
          font-family: 'BelfastGrotesk';
          font-style: normal;
          font-weight: 100 600;
          font-display: swap;
          src: local(''), url('/fonts/BelfastGrotesk-Medium.ttf') format('truetype');
        }
        @font-face {
          font-family: 'Geoform';
          font-style: normal;
          font-weight: 400;
          font-display: swap;
          src: local(''),
               url('/fonts/Geoform-Regular.woff2') format('woff2'),
               url('/fonts/Geoform-Regular.woff') format('woff');
        }
        @font-face {
          font-family: 'Geoform';
          font-style: normal;
          font-weight: 500;
          font-display: swap;
          src: local(''),
               url('/fonts/Geoform-Medium.woff2') format('woff2'),
               url('/fonts/Geoform-Medium.woff') format('woff');
        }
      `}
    />
  );
};

export default Fonts;
